var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { createContext } from "react";
import { useEnsureContext } from "@madmedical/utils";
var DocumentService;
(function (DocumentService) {
    DocumentService["Pregnancy"] = "pregnancy";
    DocumentService["Manager"] = "manager";
    DocumentService["PrePostOp"] = "pre_post_op";
    DocumentService["Basic"] = "basic";
})(DocumentService || (DocumentService = {}));
const DocumentContext = createContext(undefined);
export const DocumentProvider = DocumentContext.Provider;
export const useDocuments = (type) => {
    const _a = useEnsureContext(DocumentContext), { documents, pregnancyDocuments } = _a, rest = __rest(_a, ["documents", "pregnancyDocuments"]);
    return Object.assign({ documents: documents.filter((document) => {
            switch (type) {
                case "evaluations":
                    return "metricType" in document;
                case "general":
                    return !("metricType" in document);
                case "both":
                    return true;
            }
        }), pregnancyDocuments: pregnancyDocuments }, rest);
};
